import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { KpiList } from 'src/app/core/models/insight-configuration.model';
import { GetKpiList, SetSelectedKPIs } from 'src/app/core/store/kpi-configuration/kpi-configuration.action';
import { Subject } from 'rxjs';
import _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kpi-selection-popup',
  templateUrl: './kpi-selection-popup.component.html',
  styleUrls: ['./kpi-selection-popup.component.scss']
})
export class KpiSelectionPopupComponent implements OnInit, AfterViewChecked {

  public kpiList : KpiList[];
  public disabledKpiList : KpiList[] = [];
  public disabledSelectAll: boolean = false;
  public count = 0;
  public allSelected: boolean = false;
  public someSelected: boolean = false;
  public unsubscribe = new Subject<void>();
  public kpisLoading: boolean = true;
  public selectedPlant: any;

  form: UntypedFormGroup;

  constructor(
    public modalRef: BsModalRef,
    public store: Store,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) {
  }

  ngOnInit(): void {
    this.getKpiList();
    this.initiateForm();
    this.getSelectedPlant();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public selectAll(selected: boolean){
    this.allSelected = selected
    if(this.kpiList === null) {
      return;
    }
    this.kpiList.forEach(kpi => kpi.selected = selected);
    this.checkSomeSelected();
  }

  public onKpiSelected() {
    if(this.kpiList.length > 0){
      this.allSelected = this.kpiList?.every(kpi => kpi.selected);
      this.checkSomeSelected();
    }
  }

  public checkSomeSelected() {
    this.someSelected = this.kpiList.filter(kpi => kpi.selected).length > 0 && !this.allSelected;
    this.count = this.kpiList.filter(kpi => kpi.selected).length;
  }

  public initiateForm(): void{
    this.form = this.fb.group({
      kpi: this.fb.array([]),
    });
  }

  public getSelectedPlant() {
    //to get the selected Plant option
    this.selectedPlant =  this.store.selectSnapshot(state => state.configurations.selectedPlant);
  }

  public getKpiList() {
    this.kpiList = this.store.selectSnapshot(state => state.configurations.kpi.kpiListSelection)
    this.filterSelected();
    this.onKpiSelected();
    if(this.kpiList.length === 0) {
      this.store.dispatch(new GetKpiList())
      .subscribe((state) => {
        this.kpiList = state.configurations.kpi.kpiListSelection;
        this.filterSelected();
        this.onKpiSelected();
        this.kpisLoading = false;
      })
    }else{
      this.kpisLoading = false;
    }
  }

  public filterSelected() {
    const selectedKPIs = this.store.selectSnapshot(state => state.configurations.kpi.kpisSelected);
    const activeKpiList = this.kpiList
    .filter((kpi) => !kpi.configured)
    .map((kpi) => {
      if(selectedKPIs[0]?.hasOwnProperty("insightCategoryParameters")){
        kpi.selected = !!selectedKPIs.find(selectedKpi => selectedKpi.insightCategoryParameters.uid === kpi.uid);
      }else{
        kpi.selected = !!selectedKPIs.find(selectedKpi => selectedKpi.uid === kpi.uid);
      }
      return kpi;
    })
    const disabledKpiList = this.kpiList.filter((kpi) => kpi.configured);
    this.kpiList = activeKpiList;
    this.disabledSelectAll = this.kpiList.length === 0;
    this.disabledKpiList = disabledKpiList;
  }

  submit() {
    const selectedKpis = _.cloneDeep(this.kpiList.filter(kpi => kpi.selected));
    this.store.dispatch(new SetSelectedKPIs(selectedKpis)).subscribe(() => {
      this.modalRef.hide();
    });
  }
  
  public onCloseButtonClick() : void {
    this.modalRef.hide();

    if(this.kpiList.length === 0){
      this.router.navigateByUrl('/home');
    }
  }

}
